
import { defineComponent } from "@vue/runtime-core";
import { mapState,mapActions } from "vuex";
import CustomField from "../CustomFieldWrapper.vue";
import { BreedingRhombusSpinner } from "epic-spinners";
import { RegistrationSchema } from "./RegisterFormSchema";


export default defineComponent({
  name: "RegitserForm",
  components: {
    CustomField,
    BreedingRhombusSpinner
  },
  data() {
    return {
      defaultUserData: {
        country: "USA"
      },
      showRegAlert: false,
      regInSubmission: false,
      regAlertStyle: "bg-blue-500",
      regAlertMsg: "Please wait! Your account is being created.",
      showLoader: false,

      registerationSchema: {
        name: "required|min:3|max:100|alpha_spaces:true",
        email: "required|min:3|max:100|email",
        age: "required|numeric|age_min_value:10|age_max_value:100",
        password: "required|min:8|max:32|",
        confirmPassword: "confirmed:@password",
        country: "required",
        tos: {
          is: true
        }
      } as RegistrationSchema,

      registerationInputFields: [
        {
          label: "Name",
          field_name: "name",
          field_type: "text",
          placeholder: "Enter Name"
        },
        {
          label: "Email",
          field_name: "email",
          field_type: "text",
          placeholder: "Enter email"
        },
        {
          label: "Age",
          field_name: "age",
          field_type: "number",
          placeholder: "Enter Age"
        },
        {
          label: "Password",
          field_name: "password",
          field_type: "password",
          placeholder: "Enter Password"
        },
        {
          label: "Confirm Password",
          field_name: "confirmPassword",
          field_type: "password",
          placeholder: "Confirm Password",
          errMsg: "Password didn't match"
        }
      ]
    };
  },
  computed: {
    fieldStyle() {
      return `block w-full py-1.5 px-3 text-gray-800 border border-gray-300 transition duration-500 focus:outline-none focus:border-black rounded`;
    },
    ...mapState(["isMobile"])
  },
  methods: {
    ...mapActions(['register']),

    async regSubmit(values: RegistrationSchema) {
      this.reg_submitState();    
      // auth user
      try {
        await this.register(values)
      } 
      // handler errors
      catch (err:any) {
        console.log(err)
        this.reg_errorState();
        if (err.code === "auth/email-already-in-use") {
          this.regAlertMsg = "The email is already in use";
          return;
        }
        if (err.code === "auth/weak-password") {
          this.regAlertMsg = "Password is not strong enough";
          return;
        }
        this.regAlertMsg = "An unexpected error occured. Plrease try again later";
        return 
      }
      this.reg_successState();
      this.regAlertMsg = "Success! Your account has been created.";
    },

    reg_submitState() {
      this.regInSubmission = true;
      this.showRegAlert = true;
      this.regAlertStyle = "bg-blue-500";
      this.regAlertMsg = "Please wait! Your account is being created.";
      this.showLoader = true;
    },
    reg_successState() {
      this.showLoader = false;
      this.regAlertStyle = "bg-green-500";
    },
    reg_errorState() {
      this.showLoader = false;
      this.regAlertStyle = "bg-red-500";
      this.regInSubmission = false;
    }
  }
});
